export default __webpack_public_path__ + "static/media/granmum-login.1ed5d81c.jpg";